module.exports = __webpack_public_path__ + "static/media/logo-aria.ae014c42.webp";